(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function(){
  if (!document.getElementById('dsa-col-overlay')) {
    var mo = document.createElement('div');
    mo.className = 'dsa-modal-overlay'; mo.id = 'dsa-col-overlay';
    mo.innerHTML = '<div class="dsa-modal" role="dialog" aria-modal="true">'
      + '<button class="dsa-modal__close" id="dsa-col-close">&#x2715;</button>'
      + '<div class="dsa-modal__title" id="dsa-col-title"></div>'
      + '<div class="dsa-modal__price" id="dsa-col-price"></div>'
      + '<div class="dsa-modal__lbl" id="dsa-col-lbl">Select Size</div>'
      + '<div class="dsa-modal__sizes" id="dsa-col-sizes"></div>'
      + '<button class="dsa-modal__add" id="dsa-col-add">Add to Cart</button>'
      + '<div class="dsa-modal__err" id="dsa-col-err">Please select a size</div>'
      + '</div>';
    document.body.appendChild(mo);
  }
  var CMAP={'black':'#1a1a1a','white':'#f5f3f0','red':'#9e3a3a','blue':'#3a5068','green':'#4a6358','yellow':'#b8a05a','pink':'#b87a8a','purple':'#6e5a78','orange':'#b06040','gray':'#8a8680','grey':'#8a8680','brown':'#6b4f3a','navy':'#2a3548','beige':'#d6cfc4','cream':'#ede8e0','khaki':'#a09070','mint':'#7a9e90','teal':'#3d6e68','olive':'#6b6845','sand':'#b8a888','charcoal':'#3a3a3a','burgundy':'#6e2e35','camel':'#a88860','coral':'#b87060','rose':'#c08888','lavender':'#9090a8','sage':'#8a9882','rust':'#8e4a30','mustard':'#a08840','denim':'#3a5878'};
  function hex(n){var l=(n||'').toLowerCase().trim();if(CMAP[l])return CMAP[l];for(var k in CMAP){if(l.indexOf(k)!==-1)return CMAP[k];}return '#ccc';}
  function isCol(n){var l=(n||'').toLowerCase();return l==='color'||l==='colour'||l.indexOf('color')!==-1||l.indexOf('colour')!==-1;}
  function isSz(n){var l=(n||'').toLowerCase();return l==='size'||l.indexOf('size')!==-1;}
  var overlay=document.getElementById('dsa-col-overlay'),mTitle=document.getElementById('dsa-col-title'),mPrice=document.getElementById('dsa-col-price'),mLbl=document.getElementById('dsa-col-lbl'),mSizes=document.getElementById('dsa-col-sizes'),mAdd=document.getElementById('dsa-col-add'),mErr=document.getElementById('dsa-col-err'),mClose=document.getElementById('dsa-col-close');
  var activeVariants=[],activeSZ=null,activeSI=-1;
  function closeModal(){overlay.classList.remove('open');}
  function openModal(){overlay.classList.add('open');}
  if(mClose)mClose.addEventListener('click',closeModal);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});
  function showModal(variants,options,title,priceHTML){
    activeVariants=variants;activeSZ=null;
    var cI=-1,sI=-1;
    options.forEach(function(o,i){if(isCol(o))cI=i;if(isSz(o))sI=i;});
    if(sI===-1&&cI===-1&&options.length===1)sI=0;
    activeSI=sI;
    var sizes=[];variants.forEach(function(v){if(sI>=0&&sizes.indexOf(v['option'+(sI+1)])===-1)sizes.push(v['option'+(sI+1)]);});
    mTitle.textContent=title;mPrice.innerHTML=priceHTML;mSizes.innerHTML='';mErr.style.display='none';
    if(sizes.length>0){
      mLbl.style.display='block';
      sizes.forEach(function(sz){
        var b=document.createElement('button');b.type='button';b.className='dsa-modal__sz';b.textContent=sz;
        var avail=variants.some(function(v){return(sI<0||v['option'+(sI+1)]===sz)&&v.available;});
        if(!avail)b.classList.add('out');
        b.addEventListener('click',function(){if(b.classList.contains('out'))return;activeSZ=sz;mSizes.querySelectorAll('.dsa-modal__sz').forEach(function(x){x.classList.remove('on');});b.classList.add('on');mErr.style.display='none';});
        mSizes.appendChild(b);
      });
    }else{mLbl.style.display='none';activeSZ='__single__';}
    mAdd.textContent='Add to Cart';mAdd.disabled=false;openModal();
  }
  if(mAdd)mAdd.addEventListener('click',function(){
    if(activeSI>=0&&!activeSZ){mErr.style.display='block';return;}
    var v=null;
    for(var i=0;i<activeVariants.length;i++){var vi=activeVariants[i];if((activeSI<0||!activeSZ||activeSZ==='__single__'||vi['option'+(activeSI+1)]===activeSZ)&&vi.available){v=vi;break;}}
    if(!v)return;
    mAdd.disabled=true;mAdd.textContent='—';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})})
      .then(function(r){return r.json();})
      .then(function(){
        mAdd.textContent='Added ✓';
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count').forEach(function(el){el.textContent=c.item_count;});});
        setTimeout(function(){closeModal();mAdd.textContent='Add to Cart';mAdd.disabled=false;},900);
      })
      .catch(function(){mAdd.textContent='Error';mAdd.disabled=false;});
  });
  function initCard(card){
    var pid=card.dataset.pid;
    var variants,options;
    try{variants=JSON.parse(card.querySelector('[data-dsa-variants="'+pid+'"]').textContent);}catch(e){return;}
    try{options=JSON.parse(card.querySelector('[data-dsa-options="'+pid+'"]').textContent);}catch(e){options=[];}
    var cI=-1;options.forEach(function(o,i){if(isCol(o))cI=i;});
    var imgEl=card.querySelector('.dsa__img'),swRow=card.querySelector('.dsa__swatches'),colorLbl=card.querySelector('.dsa__color-name'),qaBtn=card.querySelector('.dsa__qa');
    if(qaBtn){qaBtn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var t=card.querySelector('.dsa__title'),p=card.querySelector('.dsa__price');showModal(variants,options,t?t.textContent:'',p?p.innerHTML:'');});}
    var colors=[];variants.forEach(function(v){if(cI>=0&&colors.indexOf(v['option'+(cI+1)])===-1)colors.push(v['option'+(cI+1)]);});
    if(colors.length>1&&swRow){
      if(colorLbl)colorLbl.textContent=colors[0];
      colors.slice(0,5).forEach(function(color,ci){
        var h=hex(color),sw=document.createElement('button');sw.type='button';sw.className='dsa__sw'+(ci===0?' on':'');
        var rgb=parseInt(h.replace('#',''),16),r=(rgb>>16)&255,g=(rgb>>8)&255,b=rgb&255;
        if(r>210&&g>210&&b>210)sw.classList.add('dsa__sw--light');
        sw.style.background=h;sw.title=color;
        sw.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();swRow.querySelectorAll('.dsa__sw').forEach(function(s){s.classList.remove('on');});sw.classList.add('on');if(colorLbl)colorLbl.textContent=color;var fnd=null;for(var i=0;i<variants.length;i++){if(cI>=0&&variants[i]['option'+(cI+1)]===color&&variants[i].featured_image){fnd=variants[i];break;}}if(fnd&&fnd.featured_image&&imgEl){imgEl.src=fnd.featured_image.src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i,'_600x$1');imgEl.srcset='';}});
        swRow.appendChild(sw);
      });
      if(colors.length>5){var m=document.createElement('span');m.className='dsa__sw-more';m.textContent='+'+(colors.length-5);swRow.appendChild(m);}
    }else if(swRow){swRow.style.display='none';if(colorLbl)colorLbl.style.display='none';}
  }
  function init(){document.querySelectorAll('.dsa__card[data-pid]').forEach(function(card){if(!card.dataset.colInit){card.dataset.colInit='1';initCard(card);}});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
  } catch(e) { console.error(e); }
})();

})();
